import React from 'react';

import { SecureProgressButton, SecureProgressButtonProps } from '../../../../general/components/secure-progress-button';
import { usePathActionMatch } from '../../selectors/path-action-match/pathActionMatch.selector';

type Props = Omit<SecureProgressButtonProps, 'size'>;

const SubmitWorkflowButton: React.FC<Props> = ({
  children,
  disabled = false,
  variant = 'contained',
  fullWidth = true,
  color = 'primary',
  ...props
}: Props) => {
  const isPathActionMatch = usePathActionMatch();

  return (
    <SecureProgressButton
      disabled={!isPathActionMatch || disabled}
      variant={variant}
      size="large"
      fullWidth={fullWidth}
      color={color}
      {...props}
    >
      {children}
    </SecureProgressButton>
  );
};

export { SubmitWorkflowButton };
